import * as React from "react";
import styled from "styled-components";
import { WIDGET_BORDER_RADIUS } from "../../../../components/widget";
import { colours } from "../../../../styles/colours";

interface ISecondaryTileProps {
  title?: string;
  tooltip?: string;
  children: React.ReactNode;
}

const TileWrapper = styled.div`
  padding: 1em;
  margin: 1em;

  :not(:first-child) {
    border-left: 2px solid ${colours.lightGrey};
  }
`;

const Title = styled.h4`
  color: ${colours.darkGrey};
  font-size: 0.7em;
  margin: 0 0 0.5em 0;
`;

export const SecondaryTile: React.FunctionComponent<ISecondaryTileProps> = ({
  title,
  children,
}) => {
  return (
    <TileWrapper>
      {title ? <Title>{title}</Title> : null}
      {children}
    </TileWrapper>
  );
};

const Wrapper = styled.div<{
  repeat: number;
  alignment: "right" | "left" | "center";
}>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.repeat}, 1fr);

  background: ${colours.white};
  text-align: ${(props) => props.alignment};
  border-radius: ${WIDGET_BORDER_RADIUS};
  font-size: 1.3em;
`;

export const SecondaryTileWrapper: React.FunctionComponent<
  Pick<React.ComponentProps<typeof Wrapper>, "alignment">
> = ({ children, alignment }) => {
  return (
    <Wrapper
      repeat={Array.isArray(children) ? children.length : 2}
      alignment={alignment}
    >
      {children}
    </Wrapper>
  );
};
